function detailToString(detail) {
    if (typeof detail === "string")
        return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((item) => {
            if (typeof item === "string")
                return item;
            if (item && typeof item === "object" && "msg" in item) {
                return String(item.msg ?? "");
            }
            return "";
        })
            .join(" ");
    }
    if (detail && typeof detail === "object")
        return JSON.stringify(detail);
    return "";
}
/**
 * Ответ бэка «текст песни не найден» — например `Text(id=549944) not found`.
 * Возникает, когда восстановленный черновик ссылается на text_id из прошлой
 * сессии/аккаунта (сменился гость, разлогин/логин под другим юзером и т.п.).
 * Значит черновик устарел — вместо красной ошибки начинаем создание заново.
 */
export function isTextNotFoundError(error) {
    const err = error;
    const data = err?.response?.data;
    const text = [
        detailToString(data?.detail),
        typeof data?.message === "string" ? data.message : "",
    ]
        .join(" ")
        .toLowerCase();
    return (/text\s*\(?\s*id[^)]*\)?\s*not\s*found/i.test(text) ||
        /текст[^.]*не\s*найден/i.test(text));
}
